import React, { Component } from 'react'
import { connect } from 'react-redux'
import { bindActionCreators } from 'redux'
import { withRouter } from '../../components/funcs/BASES/withRouter'
import endPoints from '../../components/Consts/endPoints.json'

import { FaSave, FaShapes } from 'react-icons/fa'
import { FormLayout } from '../../components/features/Layouts'
import { InputOne } from '../../components/lib/input'
import { GridBlock } from '../../components/lib/grid'

import * as BeslenmeCategoryActions from '../../redux/actions/BeslenmeCategory'

class BeslenmeCategoryForm extends Component {
  constructor(props) {
    super(props)
    this.state = {
      onProcess: false,
      beslenmeCategory_id: '',
      beslenmeCategory_text: '',
      translated: {
        en: { beslenmeCategory_text: '' },
        tr: { beslenmeCategory_text: '' }
      }
    }
    this.releatedRoutes = endPoints.find(aa => aa.name == 'BeslenmeCategory')?.routes
  }

  componentDidMount() {
    try {
      var id = this.props.router.location.state.id
      this.setState({ beslenmeCategory_id: id }, () => {
        this.props.actions.GetOne(
          this.state.beslenmeCategory_id,
          () => {
            this.setState({ onProcess: true })
          },
          () => {
            setTimeout(
              function () {
                this.setState({ onProcess: false })
              }.bind(this),
              500
            )
          },
          data => {
            this.setState({
              beslenmeCategory_text: data?.beslenmeCategory_text || '',
              translated: data?.translated || {
                en: { beslenmeCategory_text: '' },
                tr: { beslenmeCategory_text: '' }
              }
            })
          },
          () => { }
        )
      })
    } catch (err) { }
  }

  submit = () => {
    var id = this.props.router?.location?.state?.id
    if (id == null || id == '') {
      this.props.actions.Create(
        this.state,
        () => {
          this.setState({ onProcess: true })
        },
        () => {
          setTimeout(() => {
            this.setState({ onProcess: false })
          }, 500)
        },
        () => {
          this.props.router.navigate(this.releatedRoutes.get)
        },
        () => { }
      )
    } else {
      this.props.actions.Update(
        this.state,
        () => {
          this.setState({ onProcess: true })
        },
        () => {
          setTimeout(() => {
            this.setState({ onProcess: false })
          }, 500)
        },
        () => {
          this.props.router.navigate(this.releatedRoutes.get)
        },
        () => { }
      )
    }
  }

  setVal = e => {
    this.setState({ [e.target.name]: e.target.value })
  }

  render() {
    return (
      <FormLayout
        naviIcon={<FaShapes size={30} color={'white'} />}
        recordIcon={<FaSave size={30} color={'white'} />}
        recordAction={this.submit}
        activeBack={() => {
          this.props.router.navigate(this.releatedRoutes?.get)
        }}
        loading={this.state.onProcess}
      >
        <GridBlock
          container={true} xs={12} sm={12} lg={12}>
          <GridBlock title={'Beslenme Kategorisi'} container={true} xs={12} sm={12} lg={12}>
            <InputOne
              color={'success'}
              variant='filled'
              margin='none'
              required
              fullWidth
              xs={12}
              sm={12}
              lg={12}
              id='beslenmeCategory_text'
              label='Kategori Adı'
              name='beslenmeCategory_text'
              value={this.state.beslenmeCategory_text}
              onChange={this.setVal}
              helperText='Beslenme kategorisinin adını giriniz (min 2 karakter)'
            />
          </GridBlock>

          <GridBlock title='Çeviriler (Translations)' container={true} xs={12} sm={12} lg={12}>
            <GridBlock title='İngilizce (EN)' container={true} xs={12} sm={12} lg={6}>
              <InputOne
                color={'success'}
                variant='filled'
                margin='none'
                fullWidth
                xs={12}
                sm={12}
                lg={12}
                id='translated_en_beslenmeCategory_text'
                label='Category Name (EN)'
                name='translated_en_beslenmeCategory_text'
                value={this.state.translated.en.beslenmeCategory_text}
                onChange={(e) => {
                  this.setState({
                    translated: {
                      ...this.state.translated,
                      en: { ...this.state.translated.en, beslenmeCategory_text: e.target.value }
                    }
                  })
                }}
                helperText='İngilizce kategori adı'
              />
            </GridBlock>

            <GridBlock title='Türkçe (TR)' container={true} xs={12} sm={12} lg={6}>
              <InputOne
                color={'success'}
                variant='filled'
                margin='none'
                fullWidth
                xs={12}
                sm={12}
                lg={12}
                id='translated_tr_beslenmeCategory_text'
                label='Kategori Adı (TR)'
                name='translated_tr_beslenmeCategory_text'
                value={this.state.translated.tr.beslenmeCategory_text}
                onChange={(e) => {
                  this.setState({
                    translated: {
                      ...this.state.translated,
                      tr: { ...this.state.translated.tr, beslenmeCategory_text: e.target.value }
                    }
                  })
                }}
                helperText='Türkçe kategori adı'
              />
            </GridBlock>
          </GridBlock>
        </GridBlock>
      </FormLayout>
    )
  }
}

function mapStateToProps(state) {
  return {}
}

function mapDispatchToProps(dispatch) {
  return {
    actions: {
      GetOne: bindActionCreators(BeslenmeCategoryActions.GetOne, dispatch),
      Create: bindActionCreators(BeslenmeCategoryActions.Create, dispatch),
      Update: bindActionCreators(BeslenmeCategoryActions.Update, dispatch),
    }
  }
}

export default withRouter(
  connect(mapStateToProps, mapDispatchToProps)(BeslenmeCategoryForm)
)
